import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Login from "./Login";
import Signup from "./Signup";
import PortalApp from "./portal/PortalApp";
import ProtectedRoute from "./components/ProtectedRoute";
import AcceptInvite from "./AcceptInvite";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
     {/* Protected portal */}
        <Route element={<ProtectedRoute />}>
          <Route path="/portal/*" element={<PortalApp />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;